
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M31.57.693h3.864v6.134c7.287.041 14.58-.075 21.86.034 1.567-.15 2.794 1.07 2.638 2.638.115 12.732-.027 25.472.068 38.212-.068 1.376.136 2.903-.654 4.123-.995.723-2.29.627-3.456.682-6.817-.034-13.633-.02-20.456-.02v6.816h-4.24c-10.387-1.895-20.796-3.626-31.19-5.453-.008-15.902 0-31.805 0-47.7C10.52 4.339 21.037 2.485 31.568.693z","fill":"#D24625"}}),_c('path',{attrs:{"d":"M35.434 8.872h22.493v41.58H35.434v-5.454h16.359v-2.726h-16.36v-3.408h16.36v-2.727H35.44c-.007-1.336-.007-2.672-.013-4.008 2.699.838 5.773.818 8.186-.805 2.61-1.547 3.974-4.498 4.199-7.443-2.992-.02-5.985-.014-8.97-.014-.007-2.965.033-5.93-.062-8.888-1.118.218-2.236.45-3.347.688V8.872z","fill":"#fff"}}),_c('path',{attrs:{"d":"M40.212 13.555c4.738.218 8.718 4.205 8.97 8.929-2.992.034-5.984.02-8.977.02 0-2.985-.006-5.97.007-8.95z","fill":"#D24625"}}),_c('path',{attrs:{"d":"M10.936 18.701c3.701.177 8.187-1.466 11.254 1.309 2.938 3.565 2.161 10.122-2.195 12.256-1.547.79-3.32.682-5.003.627-.007 2.665-.013 5.33-.007 7.995a724.392 724.392 0 00-4.056-.34c-.061-7.28-.074-14.567.007-21.847z","fill":"#fff"}}),_c('path',{attrs:{"d":"M14.985 22.389c1.343-.062 3.006-.306 3.913.954.777 1.336.736 3.095.088 4.472-.777 1.404-2.535 1.267-3.892 1.431-.143-2.284-.13-4.567-.11-6.857z","fill":"#D24625"}})])
          )
        }
      }
    